import { Download } from "lucide-react";
import moment from "moment";
import React from "react";
import { Card, ButtonGroup, Button, Spinner, Col } from "react-bootstrap";
import Select from "react-select";

const formateDtae = (date) => date ? moment(date).format('MMMM Do YYYY, h:mm:ss a') : 'N/A'
const bkgColor = (conditon) => conditon ? "rgba(21,101,192,.985)" : "#6c757d";
const RecentActivity = ({ children }) => <div className="alert alert-recent">
  <i className="bi bi-info-circle me-2"></i>
  {children}
</div>

const RecentActivityCard = React.memo(({
  selectedModal,
  modalList,
  setSelectedModal,
  masterData,
  imageValidtion,
  gImgValidate,
  isImageLibary,
  isStyle,
  tabHandle,
  imageValidationHandle,
  isDownload,
  downloadImageValidationReport,
}) => {
  return (
    <Col md={3} className="h-100">
      <div className="d-flex justify-content-end align-items-center mb-3 flex-wrap">
        <div style={{ width: "100%" }}>
          <label className="mb-1 text-sm font-medium text-gray-700">
            Select Master *
          </label>
          <Select
            value={selectedModal}
            options={modalList}
            onChange={(selected) => setSelectedModal(selected)}
            className="w-100"
            styles={{
              control: (base) => ({
                ...base,
                minHeight: "40px",
                borderColor: "#d1d5db",
              }),
            }}
          />
        </div>
      </div>
      <Card className="h-100 dashbaord-card p-0" style={{ minHeight: "445px" }}>
        {selectedModal?.value === "stylemasters" && (
          <ButtonGroup aria-label="Basic example">
            <Button
              onClick={tabHandle}
              variant="secondary"
              style={{ backgroundColor: bkgColor(isStyle) }}
            >
              Style
            </Button>
            <Button
              onClick={tabHandle}
              variant="secondary"
              style={{ backgroundColor: bkgColor(!isStyle) }}
            >
              Cad
            </Button>
          </ButtonGroup>
        )}
        <Card.Body className="dashboard-card-body d-flex justify-content-between flex-column">
          <div className="flex-grow-1 overflow-auto">
            <h5 className="mb-3">Recent Activity</h5>
            {masterData.lastUpdated && (
              <RecentActivity>
                Last updated: {formateDtae(masterData.lastUpdated)}
              </RecentActivity>
            )}
            {masterData.totalDocument !== null &&
              <RecentActivity>
                Total Document: {masterData.totalDocument}
              </RecentActivity>
            }
            {masterData.lastTransaction && (
              <RecentActivity>
                Last Transaction: {formateDtae(masterData.lastTransaction)}
              </RecentActivity>
            )}
            {imageValidtion?.lastTimeValidate && (
              <RecentActivity>
                Last Image Validation: {formateDtae(imageValidtion.lastTimeValidate)}
              </RecentActivity>
            )}
            {isImageLibary && gImgValidate && (
              <RecentActivity>
                {gImgValidate}
              </RecentActivity>
            )}
          </div>
          {isImageLibary && (
            <div className="d-flex">
              <Button
                className="d-flex w-100 mr-1 justify-content-center"
                onClick={imageValidationHandle}
                variant="secondary"
                style={{ backgroundColor: "rgba(21,101,192,.985)" }}
              >
                Image Validation
              </Button>
              <Button
                onClick={downloadImageValidationReport}
                variant="secondary"
                disabled={isDownload}
                style={{ backgroundColor: "rgba(21,101,192,.985)" }}
              >
                {isDownload ? (
                  <Spinner animation="border" role="status" />
                ) : (
                  <Download />
                )}
              </Button>
            </div>
          )}
        </Card.Body>
      </Card>
    </Col>
  );
});

export default RecentActivityCard;